import React from "react";
import { IconInfo, IconVote } from "../icons/svg";
import { Topic } from "../tinode/topic";
import { injectIntl } from "react-intl";
import { NODE_ACTION_POLL, NODE_TYPE_MESSAGE } from "../tinode/constants";
import MessagesUtil from "../tinode/messagesUtils";
import { profile } from "../stores/storages/ProfileStorage";

class VoteNotification extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
      interval: null,
      type: NODE_ACTION_POLL.CREATE_POLL,
      user: '',
      survey: '',
      vote: '',
      msgId: null
    }

    this.onPollMessage = this.onPollMessage.bind(this);
    this.onShowNoti = this.onShowNoti.bind(this);
    this.getContext = this.getContext.bind(this);
    this.onScrollMessage = this.onScrollMessage.bind(this);
  }

  componentDidMount() {
    const { topic } = this.props;
    topic.onPollData = this.onPollMessage
  }

  onPollMessage(msg, options) {
    const { topic, tinode } = this.props;
    const { member, type, msgPoll } = options;
    const topicInfo = Topic.getThreadId(topic?.topic);
    if (topicInfo == msg.groupId && member != profile.username) {
      const topicVote = tinode.getTopicByName(MessagesUtil.getTopicId(NODE_TYPE_MESSAGE.CHAT, member));
      const vote = msgPoll?.options?.map(v => v.title).join(', ');
      this.setState({
        type: type,
        user: topicVote.getTopicName(),
        survey: msg.title,
        vote: vote,
        msgId: msg.id
      }, () => this.onShowNoti());
    }
  }

  onShowNoti() {
    this.setState((prevState) => {
      const { interval } = prevState;
      clearInterval(interval);
      return {
        ...prevState,
        isShow: false,
        interval: null,
      };
    }, () => {
      this.setState({
        isShow: true,
        interval: setInterval(() => this.setState({ isShow: false }), 5000)
      })

    })
  }

  getContext() {
    const { formatMessage } = this.props.intl;
    const { user, vote, survey, type } = this.state;
    let text = '';
    switch (type) {
      case NODE_ACTION_POLL.CREATE_POLL:
        text = formatMessage({
          id: 'poll_create_noti',
          defaultMessage: '{user} creates a survey {survey}'
        }, {
          user,
          survey
        });
        break;

      case NODE_ACTION_POLL.SEND_POLL:
        text = formatMessage({
          id: 'poll_vote_noti',
          defaultMessage: '{user} voted {vote} in survey {survey}'
        }, {
          user,
          vote,
          survey
        });
        break;
      case NODE_ACTION_POLL.ADD_ITEM_POLL:
        text = formatMessage({
          id: 'poll_add_noti',
          defaultMessage: '{user} added {vote} in the survey {survey}'
        }, {
          user,
          vote,
          survey
        });
        break;
    }

    return text;
  }

  onScrollMessage() {
    let msg = this.props.topic.findMessageById(this.state.msgId);
    this.props.onQuoteClick(msg.seq, false);
  }

  render() {
    const { isShow } = this.state;
    return (
      <React.Fragment >
        {isShow &&
          <div className="vote-notification">
            <div className="vote-container">
              <div className="content">
                <div className="icon">
                  <IconInfo />
                </div>
                <div className="context">
                  {this.getContext()}
                </div>
              </div>
              <div className="icon-vote-custom" onClick={this.onScrollMessage}>
                <IconVote />
              </div>
            </div>
          </div>
        }
      </React.Fragment >

    );
  }
}
export default injectIntl(VoteNotification);
